import styled, { css } from 'styled-components';
import { Modal as AntdModal } from 'antd';

import crossIcon from 'assets/svg/crossIcon.svg';
import { themeColor } from 'utils/mixins';
import { ThemeTokens } from 'utils/themeTokens';

interface NarrowProps {
  $narrow?: boolean;
}

interface WrapProps extends NarrowProps {
  $noPadding?: boolean;
}

interface CloseIconProps {
  $disabled?: boolean;
}

abstract class ModalStyleMixins {
  static narrowModal({ $narrow }: NarrowProps) {
    if (!$narrow) {
      return '';
    }

    return css`
      &.ant-modal {
        min-width: 0;
        max-width: calc(100vw - ${ThemeTokens.spacing('xlg')});
      }
    `;
  }

  static disabledClose({ $disabled }: CloseIconProps) {
    if (!$disabled) {
      return '';
    }

    return css`
      cursor: not-allowed;
      opacity: 0.4;
      pointer-events: none;
    `;
  }

  static narrowWrap({ $narrow, $noPadding }: WrapProps) {
    if (!$narrow || $noPadding) {
      return '';
    }

    return css`
      padding-right: ${ThemeTokens.spacing('xxlg')};
      padding-bottom: ${ThemeTokens.spacing('xlg')};
      padding-left: ${ThemeTokens.spacing('xxlg')};
    `;
  }
}

export const Modal = styled(AntdModal)<NarrowProps>`
  &.ant-modal {
    width: auto;
    min-width: 800px;
    max-width: 1024px;
  }
  ${ModalStyleMixins.narrowModal}
  & .ant-modal-body {
    padding: 0px;
  }
  & .ant-modal-container {
    padding: 0px;
    border-radius: ${({ theme }) => theme.radius.lg};
  }
  & .ant-modal-footer {
    border-top: 0px;
    padding: 0px;
    margin: 0px;
  }
  & .ant-modal-close {
    display: none;
  }
`;

export const FocusSentinel = styled.div.attrs({ tabIndex: 0, 'aria-hidden': true })`
  width: 0;
  height: 0;
  overflow: hidden;
  outline: none;
`;

export const Wrap = styled.div.attrs({ className: 'modal-content' })<WrapProps>`
  padding: ${({ $noPadding }) => ($noPadding ? '0px' : '1.5px 80px 40px 80px')};
  ${ModalStyleMixins.narrowWrap}
`;

export const CloseIcon = styled.img.attrs({
  src: crossIcon,
  alt: 'Close icon for modal',
  'data-testid': 'modalClose',
})<CloseIconProps>`
  cursor: pointer;
  ${ModalStyleMixins.disabledClose}
`;

export const CloseIconWrap = styled.div`
  display: flex;
  padding-top: 18px;
  padding-right: 14px;
  justify-content: flex-end;
`;

export const HeaderWrap = styled.div`
  margin-bottom: ${({ theme }) => theme.spacings.md};
`;

export const HeaderTitle = styled.h3`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${themeColor('darkBlue')};
  text-transform: uppercase;
  margin-bottom: 0;
`;

export const HeaderFlexbox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacings.sm};
`;

export const HeaderExplanation = styled.p`
  color: ${themeColor('black')};
`;
